import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { useProfile } from '../../../Contexts/UserProfileContext';
import SelectPrimaryColor from './SelectPrimaryColor';
import SelectSecondaryColor from './SelectSecondaryColor';
import UploadBackgroundImage from './UploadBackgroundImage';
import UploadLogo from './UploadLogo';
import SelectAdvertiser from '../Campaign/DisplayAndVideo/SelectAdvertiser';
import { useAdvertisers } from '../../../Contexts/AdvertisersContext';
import CreateQuestions from './CreateQuestions';
import GenerateLandingPage from './GenerateLandingPage';
import LeadGeneratorHome from './LeadGeneratorHome';
import LandingPageCreated from './LandingPageCreated';
import { handleUploadToAzure } from '../../../Hooks/useUpload';
import useRequest from '../../../Hooks/useRequest';
import SelectAHeadline from './SelectAHeadline';
import SelectSendToEmail from './SelectSendToEmail';

const ConnectedLeadsContainer = styled.div`
    display: flex;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const apiKey = 'dev1234';
const ConnectedLeads = () => {
    const { profile } = useProfile();
    const { advertisers, setAdvertisers, currentAdvertiser, setCurrentAdvertiser } = useAdvertisers();
    const selectedAdvertiserId = currentAdvertiser?.advertiserId;

    const role = {
        isAgency: profile.isAgency,
        isAdvertiser: profile.isIndividual,
        isSiteAdmin: profile.isSiteAdmin,
    };
    const defaultLeadGenerationData = {
        subdomain: currentAdvertiser?.companyName?.replace(/\s+/g, '').toLowerCase(),
        emailTo: '',
        theme: {
            headline: '',
            subtext: '',
            backgroundImageSrc: '',
            logoSrc: '',
            primaryColor: '',
            secondaryColor: '',
            backgroundImageColor: '',
        },
        logoFile: { file: null },
        backgroundImageFile: { file: null },
        questions: [],
        _id: '',
    };

    const [leadGenerationData, setLeadGenerationData] = useState({ ...defaultLeadGenerationData });
    const [pageIndex, setPageIndex] = useState(0);
    const [tableRows, setTableRows] = useState({ rows: [] });
    const [logFile, setLogFile] = useState(null);
    const [backFile, setBackFile] = useState(null);

    const [postData, setPostData] = useState({
        error: false,
        isLoading: false,
        success: false,
        errorText: '',
    });
    const formattedSubdomain = currentAdvertiser?.companyName
        ?.replace(/\s+/g, '')
        .replace(/'/g, '')
        .replace(/[^a-zA-Z ]/g, '')
        .toLowerCase();

    const baseURL = `${process.env.REACT_APP_API_LEAD_GEN_BASE_URL_START}${formattedSubdomain}${process.env.REACT_APP_API_LEAD_GEN_BASE_URL_END}`;

    const { data: getConfigData, mutate } = useRequest(`${baseURL}/api/config?subdomain=${formattedSubdomain}`, undefined, false, apiKey);

    const noConfig = getConfigData?._id === undefined;

    const backgroundSrc = getConfigData?.theme?.backgroundImageSrc || undefined;
    const logoSrc = getConfigData?.theme?.logoSrc || undefined;

    console.log(getConfigData, 'config');

    const convertBackgroundImagesToFiles = async () => {
        if (backgroundSrc) {
            try {
                const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/fetchFile?url=${encodeURIComponent(backgroundSrc)}`;
                const response = await axios.get(apiUrl, {
                    responseType: 'arraybuffer',
                });

                if (response.status === 200) {
                    // Extract the filename from the URL
                    const fileNameResp = decodeURIComponent(response.config.url.split('?url=')[1]);
                    console.log(fileNameResp, 'filename');

                    // Create a File object with the extracted filename
                    const backroundFile = new File([response.data], fileNameResp, {
                        type: 'image/jpeg', // Adjust based on the actual image type
                        lastModified: new Date().getTime(), // set lastModified as needed
                    });

                    // Set the File to your state or perform other actions
                    setBackFile(backroundFile);
                } else {
                    throw new Error(`Failed to fetch image. Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching or processing the background image:', error);

                // Handle the error appropriately, e.g., show a user-friendly message
            }
        }
    };

    const convertLogoImagesToFiles = async () => {
        if (logoSrc) {
            try {
                const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/fetchFile?url=${encodeURIComponent(logoSrc)}`;
                const response = await axios.get(apiUrl, {
                    responseType: 'arraybuffer',
                });

                if (response.status === 200) {
                    // Extract the filename from the URL
                    const fileNameResp = decodeURIComponent(response.config.url.split('?url=')[1]);
                    console.log(fileNameResp, 'filename');

                    // Create a File object with the extracted filename
                    const logoFile = new File([response.data], fileNameResp, {
                        type: 'image/jpeg', // Adjust based on the actual image type
                        lastModified: new Date().getTime(), // set lastModified as needed
                    });

                    // Set the File to your state or perform other actions
                    setLogFile(logoFile);
                } else {
                    throw new Error(`Failed to fetch image. Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching or processing the background image:', error);

                // Handle the error appropriately, e.g., show a user-friendly message
            }
        }
    };

    useEffect(() => {
        convertBackgroundImagesToFiles();
        convertLogoImagesToFiles();
    }, [getConfigData]);

    useEffect(() => {
        if (noConfig) {
            setLeadGenerationData({ ...defaultLeadGenerationData });
        } else {
            setTableRows({ rows: getConfigData?.questions });
            setLeadGenerationData({
                ...getConfigData,
                logoFile: { file: logFile },
                backgroundImageFile: { file: backFile },
                backgroundImageFile:
                    !getConfigData?.theme?.backgroundImageColor || getConfigData?.theme?.backgroundImageColor === '' ? { file: backFile } : undefined,
            });
        }
    }, [getConfigData, mutate, advertisers, logFile, backFile]);

    const handleNavButtonNext = () => {
        setPageIndex(pageIndex + 1);
    };
    const handleNavButtonBack = () => {
        setPageIndex(pageIndex - 1);
    };

    const saveLandingPage = async () => {
        const method = leadGenerationData._id !== '' ? 'PUT' : 'POST';
        const body = {};
        try {
            setPostData({ ...postData, isLoading: true, error: false, errorText: '' });

            const logoFileResp = await handleUploadToAzure(leadGenerationData.logoFile.file);
            let backgroundImageFileResp;

            if (leadGenerationData.theme.backgroundImageColor === '' || !leadGenerationData.theme.backgroundImageColor) {
                // no background color means there is a file uploaded
                backgroundImageFileResp = await handleUploadToAzure(leadGenerationData.backgroundImageFile.file);
                console.log(backgroundImageFileResp, 'backgroundImage azure UPLOAD resp');
            }

            if (backgroundImageFileResp || logoFileResp) {
                if (method === 'PUT') {
                    body._id = leadGenerationData._id;
                    body.emailTo = leadGenerationData.emailTo;
                }
                body.subdomain = formattedSubdomain;
                body.createEmbeddedVersion = true;
                body.davieAdvertiserId = selectedAdvertiserId.toString();
                body.theme = {
                    headline: leadGenerationData.theme.headline,
                    subtext: leadGenerationData.theme.subtext,
                    primaryColor: leadGenerationData.theme.primaryColor,
                    secondaryColor: leadGenerationData.theme.secondaryColor,
                    logoSrc: logoFileResp,
                    backgroundImageSrc: leadGenerationData.theme.backgroundImageColor ? '' : backgroundImageFileResp,
                    backgroundImageColor: leadGenerationData.theme.backgroundImageColor,
                };
                if (method === 'PUT') {
                    body.theme._id = leadGenerationData?.theme?._id;
                }
                body.questions = leadGenerationData.questions;

                // post to api
                if (method === 'PUT') {
                    await axios.put(`${baseURL}/api/config`, body, {
                        headers: {
                            'x-api-key': apiKey,
                        },
                    });
                    setPostData({
                        ...postData,
                        isLoading: false,
                        success: true,
                        error: false,
                        errorText: '',
                    });
                    mutate();
                    handleNavButtonNext();
                } else if (method === 'POST') {
                    // check if subdomain is available
                    const subdomainCheckResp = await axios.get(`${baseURL}/api/config/subdomain?subdomain=${formattedSubdomain}&check=true`, {
                        headers: {
                            'x-api-key': apiKey,
                        },
                    });
                    const subdomainIsAvailable = subdomainCheckResp?.data?.subdomainAvailable === true;
                    if (subdomainIsAvailable) {
                        // if its available then reserve it
                        const subdomainCreateBody = {
                            davieAdvertiserId: selectedAdvertiserId.toString(),
                            subdomain: formattedSubdomain,
                            emailTo: leadGenerationData.emailTo,
                        };
                        const subdomainCreatedResp = await axios.post(`${baseURL}/api/config/subdomain`, subdomainCreateBody, {
                            headers: {
                                'x-api-key': apiKey,
                            },
                        });

                        const subdomainCreated = subdomainCreatedResp?.data?.acknowledged === true;

                        if (subdomainCreated) {
                            // if reserved then create landing page
                            await axios.post(`${baseURL}/api/config`, body, {
                                headers: {
                                    'x-api-key': apiKey,
                                },
                            });
                            setPostData({
                                ...postData,
                                isLoading: false,
                                success: true,
                                error: false,
                                errorText: '',
                            });
                        }
                        mutate();
                        handleNavButtonNext();
                    } else {
                        // subdomain already reserved, just create landing page
                        await axios.post(`${baseURL}/api/config`, body, {
                            headers: {
                                'x-api-key': apiKey,
                            },
                        });
                        setPostData({
                            ...postData,
                            isLoading: false,
                            success: true,
                            error: false,
                            errorText: '',
                        });
                        mutate();
                        handleNavButtonNext();
                    }
                }
            }
        } catch (err) {
            setPostData({
                ...postData,
                isLoading: false,
                success: false,
                error: true,
                errorText: err?.response?.data?.updateResponse?.message,
            });
        }
    };

    useEffect(() => {
        if (currentAdvertiser === null) {
            setPageIndex(0);
        } else {
            setLeadGenerationData({
                ...leadGenerationData,
                subdomain: currentAdvertiser?.companyName,
            });
        }
    }, [advertisers]);

    const shouldRenderSelectAdvertiser = () => {
        if (role.isAgency) {
            return (
                <SelectAdvertiser
                    handleNavButtonBack={handleNavButtonBack}
                    handleNavButtonNext={handleNavButtonNext}
                    advertisers={advertisers}
                    setAdvertisers={setAdvertisers}
                    currentAdvertiser={currentAdvertiser}
                    setCurrentAdvertiser={setCurrentAdvertiser}
                    setLeadGenerationData={setLeadGenerationData}
                    leadGenerationData={leadGenerationData}
                />
            );
        }

        if (role.isAdvertiser) {
            return setPageIndex(2);
        }
    };

    const determinePage = () => {
        switch (pageIndex) {
            case 0:
                return <LeadGeneratorHome handleNavButtonNext={handleNavButtonNext} />;
            case 1:
                return shouldRenderSelectAdvertiser();
            case 2:
                return (
                    <SelectAHeadline
                        role={role}
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        setLeadGenerationData={setLeadGenerationData}
                        leadGenerationData={leadGenerationData}
                        setPageIndex={setPageIndex}
                    />
                );
            case 3:
                return (
                    <SelectPrimaryColor
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        setLeadGenerationData={setLeadGenerationData}
                        leadGenerationData={leadGenerationData}
                    />
                );
            case 4:
                return (
                    <SelectSecondaryColor
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        setLeadGenerationData={setLeadGenerationData}
                        leadGenerationData={leadGenerationData}
                    />
                );
            case 5:
                return (
                    <UploadLogo
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        setLeadGenerationData={setLeadGenerationData}
                        leadGenerationData={leadGenerationData}
                    />
                );
            case 6:
                return (
                    <UploadBackgroundImage
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        setLeadGenerationData={setLeadGenerationData}
                        leadGenerationData={leadGenerationData}
                    />
                );
            case 7:
                return (
                    <CreateQuestions
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        setLeadGenerationData={setLeadGenerationData}
                        leadGenerationData={leadGenerationData}
                        tableRows={tableRows}
                        setTableRows={setTableRows}
                    />
                );
            case 8:
                return (
                    <SelectSendToEmail
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        setLeadGenerationData={setLeadGenerationData}
                        leadGenerationData={leadGenerationData}
                        tableRows={tableRows}
                        setTableRows={setTableRows}
                    />
                );
            case 9:
                return (
                    <GenerateLandingPage
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        setLeadGenerationData={setLeadGenerationData}
                        leadGenerationData={leadGenerationData}
                        saveLandingPage={saveLandingPage}
                        postData={postData}
                        noConfig={noConfig}
                    />
                );
            case 10:
                return (
                    <LandingPageCreated
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        setLeadGenerationData={setLeadGenerationData}
                        leadGenerationData={leadGenerationData}
                    />
                );

            default:
                return (
                    <SelectAdvertiser
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        advertisers={advertisers}
                        setAdvertisers={setAdvertisers}
                        setLeadGenerationData={setLeadGenerationData}
                        leadGenerationData={leadGenerationData}
                    />
                );
        }
    };

    return <ConnectedLeadsContainer>{determinePage()}</ConnectedLeadsContainer>;
};

ConnectedLeads.propTypes = {};

ConnectedLeads.defaultProps = {};
export default ConnectedLeads;
